import request from '@/utils/request'

/**
 * 套餐列表
 * @param {*} params token, userId
 * @returns
 */
export const packageList = params => {
  return request({
    method: 'get',
    url: '/mobile/package/list',
    params: params
  })
}

/**
 * 流量包充值
 * @param {*} params { iccid：iccidnum }
 * @returns
 */
export const rechargePackage = params => {
  return request({
    method: 'POST',
    url: '/mobile/package/recharge',
    params
  })
}

/**
 * 代理套餐
 * @param {*} params { iccid：iccidnum }
 * @returns
 */
export const agentRechargePackage = params => {
  return request({
    method: 'POST',
    url: '/mobile/sim/agentRechargePackage',
    params
  })
}
/**
 * 代理套餐
 * @param {*} params { iccid：iccidnum }
 * @returns
 */
export const agentMethodRecharge = params => {
  return request({
    method: 'POST',
    url: '/mobile/sim/agentMethodRecharge',
    params
  })
}
/**
 * 代理套餐列表
 * @param {*} params token, userId
 * @returns
 */
export const agentPackageList = params => {
  return request({
    method: 'get',
    url: '/mobile/sim/agentPackageList',
    params: params
  })
}

/**
 * 我的售价：设置
 * @param {*} params token, userId
 * @returns
 */
export const setPackageConfig = params => {
  return request({
    method: 'post',
    url: '/mobile/sim/packageConfig/set',
    data: params
  })
}
/**
 * 下级代理套餐配置查询
 * @param {*} params token, userId
 * todo
 * @returns
 */
export const subPackageConfig = params => {
  return request({
    method: 'post',
    url: '/mobile/sim/packageConfig/sub',
    data: params
  })
}
